<div class="dialog-content">
  <h2>
    <app-icon-button Icon="error" Appearance="default" />
    {{ data.title }}
  </h2>
  <p>{{ data.message }}</p>
  @if (data.isForceClose) {
    <app-button (Click)="close()" [Text]="data.linkTitle!" [FullWidth]="true" />
  } @else {
    <app-button [Link]="data.redirectLink!" (Click)="close()" [Text]="data.linkTitle!" [FullWidth]="true" />
  }
</div>
